import { MessageMap, } from "@shared";
import { writable } from "../../utils/stores";
import { notEq } from "../utils";
export class MessageLocalUpdates {
    deleted;
    editedContent;
    cancelledReminder;
    undeletedContent;
    revealedContent;
    prizeClaimed;
    p2pSwapStatus;
    reactions = [];
    pollVotes = [];
    threadSummary;
    tips = new Map();
    hiddenMessageRevealed;
    blockLevelMarkdown;
    proposalTally;
    lastUpdated = 0;
    ogPreviews;
    messagePreviews;
    isEmpty() {
        return Object.entries(this).every(([key, value]) => key === "lastUpdated" ||
            value === undefined ||
            (Array.isArray(value) && value.length === 0) ||
            (value instanceof Map && value.size === 0));
    }
}
export const messageLocalUpdates = writable(new MessageMap(), undefined, notEq);
